module.exports = __webpack_public_path__ + "static/media/img-close.d650d664.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/img-close.svg
// module id = 37
// module chunks = 0